import React from "react";
import PublicHeader from "../Header/PublicHeader";
import Footer from "../Footer";
import { motion } from "framer-motion";

const NewsAndUpdates = () => {
  const posts = [
    "https://www.linkedin.com/embed/feed/update/urn:li:share:7485640405623934976",
    "https://www.linkedin.com/embed/feed/update/urn:li:share:7485261311753228288" ,
    "https://www.linkedin.com/embed/feed/update/urn:li:share:7484138309259214848",
    "https://www.linkedin.com/embed/feed/update/urn:li:share:7483449932943876097",
    "https://www.linkedin.com/embed/feed/update/urn:li:share:7483823118344675328",
    "https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7481614056173359104",
    "https://www.linkedin.com/embed/feed/update/urn:li:share:7480925146065842177",
    "https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7459529701263515648",
    "https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7451332966561247232",
    "https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7448304162821566464",
    "https://www.linkedin.com/embed/feed/update/urn:li:share:7446107741003218944",
    "https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7420118294998962176"
  ];
  return (
    <>
      <PublicHeader />

      {/* Page Banner */}
      <div className="section-header">
        <div className="header-content px-5">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-left"
          >
            <h1 className="text-center display-4 fw-bold mb-2 text-white">
              Latest Updates
            </h1>
          </motion.div>
        </div>
        <div className="overlay"></div>
      </div>

      {/* Main Feed */}
     <div className="bg-gray-50 min-h-screen py-10 px-4">
  <div className="max-w-7xl mx-auto">
    <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
      {posts.map((post, index) => (
        <div
          key={index}
          className="bg-white rounded-2xl shadow-lg overflow-hidden "
        >
          <iframe
            src={post}
            style={{
              border: "none",
              width: "100%",
              height: "450px",
            }}
            className="w-full sm:h-[350px] md:h-[400px] lg:h-[420px] "
            title={`LinkedIn Post ${index + 1}`}
            allowFullScreen
          ></iframe>
        </div>
      ))}
    </div>
  </div>
</div>
      <Footer />
    </>
  );
};

export default NewsAndUpdates;
